import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CircularProgress from '@material-ui/core/CircularProgress';

const TwoStepsDownloadButton = props => {
  const {
    className,
    requestLabel,
    pendingLabel,
    downloadLabel,
    isPending,
    downloadEnable,
    onRequest,
    onDownload,
  } = props;

  if (isPending) {
    return (
      <button className={classNames('primary disabled', className)} disabled={true}>
        <span>
          {pendingLabel || requestLabel}
          <div className="button-circular-progress-container">
            <CircularProgress
              classes={{ circle: 'circular-progress-circle-copy-color-medium' }}
              size={20}
              thickness={3}
            />
          </div>
        </span>
      </button>
    );
  }

  if (downloadEnable) {
    return (
      <button className={classNames('primary', className)} onClick={onDownload}>
        <span>{downloadLabel}</span>
      </button>
    );
  }

  return (
    <button className={classNames('primary', className)} onClick={onRequest}>
      <span>{requestLabel}</span>
    </button>
  );
};

TwoStepsDownloadButton.defaultProps = {
  downloadEnable: false,
};

TwoStepsDownloadButton.propTypes = {
  className: PropTypes.string,
  requestLabel: PropTypes.string,
  pendingLabel: PropTypes.string,
  downloadLabel: PropTypes.string,
  isPending: PropTypes.bool,
  downloadEnable: PropTypes.bool,
  onRequest: PropTypes.func,
  onDownload: PropTypes.func,
};

export default TwoStepsDownloadButton;
